const icon = require('vue-svgicon');
icon.register({
    'arrow-big': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<path pid="0" d="M16 0C7.178 0 0 7.178 0 16s7.178 16 16 16 16-7.178 16-16S24.822 0 16 0zm0 31.288C7.57 31.288.712 24.43.712 16S7.57.711 16 .711 31.288 7.569 31.288 16c0 8.43-6.858 15.288-15.288 15.288z"/><path pid="1" d="M17.337 11.429l5.065 4.516H9.034v.712h13.368l-5.065 4.516.474.531 6.06-5.403-6.06-5.403z"/>`,
    },
});
